module.exports = __webpack_public_path__ + "img/magic-87-6.a77014bd.png";